import { useQuery } from '@tanstack/react-query';
import { logUnknownErrorResponse } from '@hungryroot/o11y';
import {
  StatusCode,
  getApiV2RewardsCustomersCustomerIdRewardCredits,
} from '@hungryroot/rest';

export function useGetCustomerRewardCredits(
  options: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: ['customerRewardCredits'],
    queryFn: async () => {
      const resp = await getApiV2RewardsCustomersCustomerIdRewardCredits();
      if (resp.status !== StatusCode.SuccessOK) {
        logUnknownErrorResponse('Failed to fetch customer reward credits', {
          key: 'useGetCustomerRewardCredits',
          error: JSON.stringify(resp.data, null, 2),
          status: resp.status,
        });
        throw new Error(JSON.stringify(resp.data, null, 2));
      }
      return {
        ...resp.data,
        milestones: resp.data.tiers.map((tier) => ({
          threshold: tier.threshold,
          rewardCredits: tier.reward,
        })),
      };
    },
    ...options,
    gcTime: 5 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    retry: 0,
  });
}
